"use strict";

angular.module("core")
.factory("tokenInterceptor", function($rootScope, $q, $window, $cookies, $injector, appConfig) {
    return {
        request: function(config) {
            config.headers = config.headers || {};
            if ($cookies.get("token") && !config.disableTokenForRequest) {
                config.headers.Authorization = "Token " + $cookies.get("token");
            }

            if (window.app.DEBUG) {
                config.headers["ngrok-skip-browser-warning"] = "True";
                config.headers["Bypass-Tunnel-Reminder"] = "True";
            }

            return config;
        },
        responseError: function(rejection) {
            // TODO: use an angular service
            switch (rejection.status) {
                case 401:
                    $injector.get("UserService").clearTokenAndUser(); // UserService can't be used directly, Circular reference error
                    $injector.get("$state").go("login"); // // $state can't be used directly, Circular reference error
                    break;
                case 403:
                    // todo: WEG-331 handle api permissions here
                    if (appConfig.APP === "customer") {
                        if (rejection.data.detail === "USER_MUST_SELECT_COMPANY") {
                            $injector.get("$state").go("customer-listing");
                            $injector.get("FlashBag").clearAll();
                            var gettextCatalog = $injector.get("gettextCatalog");
                            $injector.get("FlashBag").warning(
                                gettextCatalog.getString("You have been granted access to more than one company, you have to select one."),
                                true,
                                0
                            );
                        }
                    }
                    break;
                case 502:
                // TODO WEG-3035 : When server is down http status are transform with -1 by AngularJS
                //   Source: https://docs.angularjs.org/api/ng/service/$http#$http-returns
                //   Apparently, this is due to CORS error. Nginx don't sent the right policy when down. So CORS error
                //   make the 502 a -1 status...
                //      Source: https://stackoverflow.com/a/27851884
                case -1:
                    // local fix because version.json doesn't work in vagrant
                    if (rejection.config.url.indexOf('versions.json') == -1) {
                        $injector.get('$state').go('502');
                    }
                    break;
            }
            return $q.reject(rejection);
        }
    };
})

.config(["$httpProvider", function($httpProvider) {
    $httpProvider.interceptors.push("tokenInterceptor");
    $httpProvider.defaults.withCredentials = true;
}]);



//////////////////
// WEBPACK FOOTER
// ./core/API.js
// module id = 368
// module chunks = 0